'use strict';
const angular = require('angular');
const {isString} = angular;

OnReadFileDirective.$inject = [
  '$exceptionHandler',
  '$parse',
];

/**
 * Supports onReadFile and onReadError
 *
 * onReadFile
 *  locals:
 *    $event: the actual event data generated by the file reader
 *    $file: the read contents of the file
 *
 * onReadError
 *  locals:
 *    $error: the error object if an error is thrown while reading the file.
 *
 * If onReadError is not supplied, the error will be passed to $exceptionHandler instead.
 */
export function OnReadFileDirective(
  $exceptionHandler,
  $parse,
) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      const vm = {};
      vm.onChange = onChange;
      element.on('change', vm.onChange);
      element.on('$destroy', () => element.off('change', vm.onChange));

      function onChange(onChangeEvent) {
        const reader = new FileReader();

        reader.onload = function onRead(onLoadEvent) {
          scope.$apply(function applyOnRead() {
            try {
              if (isString(attrs.onReadFile)) {
                const handler = $parse(attrs.onReadFile);
                const locals = {$event: onLoadEvent, $file: onLoadEvent.target.result};

                handler(scope, locals);
              }
            } catch (error) {
              console.warn('onReadFile failed to parse method to call. Expected angular expression. ' + element);
            }
          });
        };

        reader.onerror = function onError(error) {
          scope.$apply(function applyOnError() {
            try {
              if ('onReadError' in attrs) {
                const handler = $parse(attrs.onReadError);
                const locals = {$error: error};

                handler(scope, locals);
              } else {
                $exceptionHandler(error, "onReadFile failed to read the file");
              }
            } catch (error) {
              console.warn('onReadError failed to parse method to call. Expected angular expression. ' + element);
            }
          });
        };

        reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/file-dialog/OnReadFileDirective.js